/**
 * Utility function to reduce a data path by a specified number of levels, used for targeting parent nodes in the table's bodyData structure.
 *
 * @param dataPath - The original data path string (e.g., "/columns/0/subGroups/1")
 * @param levels - The number of levels to reduce from the end of the path
 * @returns The reduced data path string (e.g., "/columns/0" if levels is 2)
 */
export const reduceDataPath = (dataPath: string, levels: number): string => {
  const parts = dataPath.split("/").filter(Boolean);
  if (parts.length <= levels) {
    return "";
  }
  return "/" + parts.slice(0, -levels).join("/");
};
